/* raw layout hash: auth-web-layout:413f88a418bebc1fe9e2b8bd68fe49f21dd40663efb9442aabb87469769f699c */
import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { APP_NAME } from '../config/branding.js';

/**
 * Layout `auth-web-layout`
 * Source shell: RawHTMLDesign/layouts/auth-web-layout.html
 *
 * The anonymous entry shell. Unlike the default shells it has **no navbar and no
 * footer**: the raw shell is a bare full-height dark canvas whose only chrome is
 * the company name kept in the DOM but hidden
 * (`<div style="display: none !important" aria-hidden="true">CreativeStudioOS</div>`
 * plus `.company-name-area { display: none !important }`), with `html, body`
 * reset to full height, zero padding and `overflow-x: hidden`. All of that is
 * reproduced on the `.auth-shell` wrapper instead of on `<body>`, so this layout
 * doesn't have to fight the default shells' 80px navbar offset.
 *
 * Pages using this layout: Sign-in / SSO Redirect Screen — the only anonymous
 * page in scope. Its login affordance is the page's own sign-in form, which is
 * why no log-in control is added to the chrome here. A visitor who is already
 * signed in does get an escape hatch (their identity + log out), so the layout
 * never leaves an authenticated session stranded on the login canvas.
 */
export default function AuthWebLayout({ children }) {
  const { isAuthenticated, user, logout } = useAuth();

  return (
    <div className="auth-shell">
      {/* The shell keeps the company name in the DOM, visually hidden. */}
      <div className="auth-shell__brand company-name-area" aria-hidden="true">
        {APP_NAME}
      </div>

      {isAuthenticated ? (
        <div className="auth-shell__session">
          <span className="small text-body-secondary">
            Signed in as {user?.name || user?.email}
          </span>
          <button type="button" className="btn btn-sm btn-outline-primary" onClick={logout}>
            <i className="fa fa-sign-out-alt me-2" aria-hidden="true" />
            Log out
          </button>
        </div>
      ) : null}

      {/* <!-- main content --> */}
      <main className="auth-shell__main" id="main-content">
        {children ?? <Outlet />}
      </main>
    </div>
  );
}
